import { useSelector } from "react-redux";

// convenience hook to check logged in state
export default function useLoggedIn() {
  const user = useSelector((state) => state.user.user);
  return !!user;
}
